import React, { useEffect, useState } from "react";
import { fetchData, fetchFormData } from "../../utils/options";
import { useParams, Link } from "react-router-dom";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
// import Content2Header from "./Content2Header";
import { useNavigate } from "react-router-dom";
import { BaseUrl, ImageUrl } from "../..";
const StudentRenewalContent = () => {
  const { id } = useParams();
  const [content, setContent] = useState(null);

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);
  // Fetch by ID
  const fetchContentById = async (id) => {
    try {
      const result = await fetchData(`student/getbyid/${id}`, {}, "POST");

      if (result?.success || result?.code === 200) {
        setContent(result.data);
      }
    } catch (error) {
      console.error("Error fetching content:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContentById(id);
  }, [id]);

  const statusLabel = {
    0: "Pending",
  
    1: "Approved",
   
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };
  return (
    <>
      <>
        <Header />
        <NavigationMenu />
        <main className="nxl-container">
          <div className="nxl-content">
            <PageHeader />
            <div className="main-content">
              <div className="card shadow-sm border-0 mb-4 p-2">
                <div
                  className="card-header py-3"
                  style={{ backgroundColor: "#0e606e" }}
                >
                  <h5 className="mb-0 text-white">
                    Student Details & Payout Details
                  </h5>
                </div>

                <div className="card-body p-3 fw-bold">
                  {/* Student Details Table */}
                  <div
                    className="card-header py-3"
                    style={{ backgroundColor: "#0e606e" }}
                  >
                    <h5 className="mb-0 text-white">Student Details </h5>
                  </div>
                  <table className="table table-bordered mb-4">
                    <tbody>
                      <tr>
                        <td>
                          <strong>Name:</strong>
                        </td>
                        <td>{content?.name || "-"}</td>
                        <td>
                          <strong>Email:</strong>
                        </td>
                        <td>{content?.email || "-"}</td>
                        <td>
                          <strong>Phone:</strong>
                        </td>
                        <td>{content?.phone || "-"}</td>
                      </tr> 
                      <tr>
                        <td>
                          <strong>Course:</strong>
                        </td>
                        <td>{content?.course_name || "-"}</td>
                        <td>
                          <strong>Semester:</strong>
                        </td>
                        <td>{content?.semester_name || "-"}</td>
                        <td>
                          <strong>Gender:</strong>
                        </td>
                        <td>{content?.gender || "-"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Email Verified:</strong>
                        </td>
                        <td>{content?.otp_verify === 1 ? "Yes" : "No"}</td>
                        {/* <td>
                          <strong>Subscripton Status:</strong>
                        </td> */}
                        {/* <td className="badge bg-info text-white fw-bold">{statusLabel[content?.payouts[0]?.status]}</td> */}
                      </tr>
                    </tbody>
                  </table>

                  {/* Payout Details Table */}

                  {content?.payouts?.length > 0 &&
                    content.payouts.map((payout, index) => (
                      <div>
                        <div
                          className="card-header py-3"
                          style={{ backgroundColor: "#0e606e" }}
                        >
                          <h5 className="mb-0 text-white">Payout Details</h5>
                        </div>
                        <table
                          key={index}
                          className="table table-bordered mb-4"
                        >
                          <tbody>
                            <tr>
                              <td>
                                <strong>Package Name</strong>
                              </td>
                              <td>{payout.package_name || "-"}</td>

                              <td>
                                <strong>Amount</strong>
                              </td>
                              <td>₹{payout.amount || 0}</td>
                            </tr>

                            <tr>
                              <td>
                                <strong>Subs. Start Date</strong>
                              </td>
                              <td>{formatDate(payout.activate_date)}</td>

                              <td>
                                <strong>Subs. End Date</strong>
                              </td>
                              <td>{formatDate(payout.deactivate_date)}</td>
                            </tr>

                            <tr>
                              <td>
                                <strong>Validity</strong>
                              </td>
                              <td>
                                {payout.validity_period
                                  ? `${payout.validity_period} days`
                                  : "-"}
                              </td>

                              <td>
                                <strong>Created At</strong>
                              </td>
                              <td>{formatDate(payout.created_at)}</td>
                            </tr>

                            <tr>
                              <td>
                                <strong>UTR Number</strong>
                              </td>
                              <td>{payout.utr_number || "-"}</td>

                              <td>
                                <strong>Receipt</strong>
                              </td>
                              <td>
                                {payout.payment_receipt ? (
                                  <a
                                    href={`${ImageUrl}${payout.payment_receipt}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-success btn-sm"
                                  >
                                    View Receipt
                                  </a>
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    </>
  );
};

export default StudentRenewalContent;
